<template>
  <div class="pros">
    <div class="title">
      <div class="a-t">公益项目 <span>/ charitable projects</span></div>
      <ul class="nav clearfix">
        <li><a class="active" href="javascript:;" type="" @click="changeNav">全部</a></li>
        <li><a href="javascript:;" type="教育" @click="changeNav">教育</a></li>
        <li><a href="javascript:;" type="医疗" @click="changeNav">医疗</a></li>
        <li><a href="javascript:;" type="养老" @click="changeNav">养老</a></li>
        <li><a href="javascript:;" type="助残" @click="changeNav">助残</a></li>
        <li><a href="javascript:;" type="扶贫" @click="changeNav">扶贫</a></li>
        <li><a href="javascript:;" type="环保" @click="changeNav">环保</a></li>
      </ul>
    </div>
    <div class="content">
      <a-spin v-if="loading" tip="Loading..."><div class="spin-content"></div></a-spin>
      <ul>
        <li v-for="(pro, index) in proList" :key="'pro' + index">
          <div class="img"><img :src="pro.bgUrl"></div>
          <div class="text">
            <div class="title">{{pro.name}}</div>
            <div class="desc">{{pro.desc}}</div>
            <div class="opt">
              <i :pId="pro.id" @click="toDetail">查看详情<a-icon type="caret-right" /></i>
            </div>
          </div>
        </li>
      </ul>
      <div class="con-empty" v-if="isEmpty"><img src="../../assets/empty.png"/><br/><br/>暂时无数据…</div>
      <div class="paging">
        <a-pagination showSizeChanger :pageSize.sync="pageSize" @change="pageChange" @showSizeChange="onShowSizeChange" :total="total" v-model="current"/>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'pros',
  data () {
    return {
      loading: true,
      ajaxList: [
        {id: 1, bgUrl: ["http://172.21.204.116:8444/files/pros/gy11.png"], name: "“启航助学”专项基金", tips: "", type: "教育", desc: "在2015-2018年间，“启航助学”专项基金共资助426名苏州贫困家庭学子助学金213万元，惠及10余所中小学和大学，为家庭贫困但成绩优异的同学们顺利完成学业提供保障"},
        {id: 2, bgUrl: ["http://172.21.204.116:8444/files/pros/gy21.png"], name: "苏州大学金螳螂建筑学院教育发展基金", tips: "", type: "教育", desc: "金螳螂为支持苏州大学金螳螂建筑学院的发展，在苏州大学设立了苏大金螳螂建筑学院教育发展基金。自2012年起，分别设立特色学科建设、国际化办学、金螳螂奖助学金、金螳螂奖教金，2017年起增设高素质人才建设项目"},

        {id: 3, bgUrl: ["http://172.21.204.116:8444/files/pros/gy31.png"], name: "“情暖心窝”爱心救助基金", tips: "", type: "医疗", desc: "“情暖心窝”专项基金是由金螳螂公益慈善基金会于2015年在苏大附属儿童医院捐赠设立，累计捐赠150万元，用于帮助患先天性心脏病或重度听力障碍的贫困儿童得到及时救治、发展儿童健康慈善事业，回报社会"},
        {id: 4, bgUrl: ["http://172.21.204.116:8444/files/pros/gy41.png"], name: "“生命之光”爱心救助专项基金", tips: "", type: "医疗", desc: "2015年，金螳螂公益慈善基金会在苏大附属第一、第二医院捐赠成立“生命之光”爱心救助专项基金"},
        {id: 5, bgUrl: ["http://172.21.204.116:8444/files/pros/gy51.png"], name: "金螳螂“工业园区慈善医疗”专项基金", tips: "", type: "医疗", desc: "2015年，金螳螂公益慈善基金会捐资在苏州工业园区捐赠成立“金螳螂慈善医疗专项基金”"},
        
        {id: 6, bgUrl: ["http://172.21.204.116:8444/files/pros/gy61.png"], name: "老人日间照料中心", tips: "", type: "养老", desc: "苏州的老年人口已连续三年创历史新高，其中80周岁以上高龄人口已突破25万人，福利性养老机构和子女供养的养老服务模式，远远不能满足不断增长的老年人口的需要，养老问题亟待社会公益力量给予支持和帮助"},
        
        {id: 7, bgUrl: ["http://172.21.204.116:8444/files/pros/gy71.png"], name: "幸福亮居工程", tips: "", type: "助残", desc: "为了帮助苏州大市范围内部分贫困残疾人家庭改善居家生活环境，消除居家生活障碍，提升生活品质，金螳螂公益慈善基金会联合苏州市残联、苏州市慈善总会、苏州市残疾人基金会共同发起了“幸福亮居”改造工程"},
        
        {id: 8, bgUrl: ["http://172.21.204.116:8444/files/pros/gy81.png"], name: "“千人工匠”精准帮扶计划", tips: "", type: "扶贫", desc: "金螳螂慈善公益基金会受贵州省、陕西省政府委托，自2016年5月起，金螳螂公益慈善基金会的工作人员通过苏州派驻当地挂职官员多次深入大山，实地调研走访10多个乡村了解民情、了解需求"},
        
        {id: 9, bgUrl: ["http://172.21.204.116:8444/files/pros/gy91.png"], name: "盐城阜宁灾区", tips: "", type: "环保", desc: "6月23日下午14:30左右，江苏盐城阜宁县等地遭受冰雹、龙卷风袭击，造成大量房屋倒塌、人员伤亡、道路受损等灾害。灾害发生后，金螳螂公益慈善基金会代表全体金螳螂人驱车赶往灾区，将鲜花、慰问金带去受灾员工家中，祝愿伤者早日康复"},
      ],
      proList: [],
      current: 1,
      pageSize: 10,
      total: 0,
      tip: "",
      isEmpty: false
    }
  },
  components: {
  },
  mounted() {
    this.init();
  },
  methods: {
    init () {
      this.getList();
    },
    getList () {
      this.loading = true;
      this.proList = [];
      this.isEmpty = false;
      setTimeout(()=>{
        if(this.tip){
          var tempArr = [];
          this.ajaxList.forEach((ele)=>{
            if(ele.type == this.tip){
              tempArr.push(ele);
            }
          })
          this.proList = tempArr;
        }else{
          this.proList = this.ajaxList;
        }
        this.total = this.proList.length;
        this.loading = false;
        if(this.proList.length <= 0){
          this.isEmpty = true;
        }

      },500)
      // this.$store.dispatch('ajaxProList', {
      //   pageIndex: this.current,
			// 	pageSize: this.pageSize,
			// 	name: "捐赠",
			// 	tip: this.tip
      // }).then((data) => {
      //   this.total = data;
      //   this.proList = this.$store.state.Project.proList;
      //   this.loading = false;
      //   if(this.proList.length <= 0){
      //     this.isEmpty = true;
      //   }
      // })
    },
    pageChange (page) {
      this.pageNo = page;
      this.getList();
    },
    onShowSizeChange() {
      this.getList();
    },
    changeNav (event) {
      var item = event.currentTarget,
          type = item.getAttribute('type');
      if(!item.classList.contains('active')){
        document.querySelector('.active').classList.remove('active');
        item.classList.add('active');
        this.tip = type;
        this.getList();
      }
    },
    toDetail () {
      var item = event.currentTarget,
          pId = item.getAttribute('pId');
      this.$router.push("prod/" + pId);
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '../../scss/views/pros';
</style>
